import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const PageToolbar_Box_1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  &[data-centered] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      padding-right: 24px;
    }
  }
`;

export const PageToolbar_Box_2 = styled.div`
  display: block;
  position: relative;
  z-index: 1;
  padding-block: 6px;
  padding-inline: ${gutterWidth / 2}px;
  flex-wrap: wrap;
  align-items: center;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    display: flex;
  }
`;
